export default __webpack_public_path__ + "static/media/DemoDay.e25a5434.svg";